
//定制弹窗配置类
class DialogConfig {
  static target;
  constructor() { }
  static baseObj = {
    titleAlign: 'left',
    data: {},
    keepAlive: true,
    footerHide: true,
    maskClosable: false,
  }

  static customConfig = {
    modifyRatioConfig: {
      title: t('修改折扣比例'),
      width: '400',
      name: 'modifyRatio',
      url: require('@/views/modal/orderCenter/modifyRatio.vue').default,
      excludeString: 'modifyRatio',
    },
    matchGiftRelyConfig: {
      title: t('匹配赠品挂靠关系'),
      width: '900',
      name: 'matchGiftRely',
      url: require('@/views/modal/orderCenter/matchGiftRely.vue').default,
      excludeString: 'matchGiftRely',
    },
    changeInvoiceConfig: {
      title: t('修改发票信息'),
      width: '900',
      name: 'changeInvoice',
      url: require('@/views/modal/orderCenter/changeInvoice.vue').default,
      excludeString: 'changeInvoice',
    },
    changeOriginalTidConfig: {
      title: t('修改原始平台单号'),
      width: '400',
      name: 'changeOriginalTid',
      url: require('@/views/modal/orderCenter/changeOriginalTid.vue').default,
      excludeString: 'changeOriginalTid',
    },
    giftExchangeDeadlineConfig: {
      title: t('修改兑换截止时间'),
      width: '400',
      name: 'giftExchangeDeadline',
      url: require('@/views/modal/orderCenter/giftExchangeDeadline.vue').default,
      excludeString: 'giftExchangeDeadline',
    },
    expressForwardConfig: {
      title: t('快递转寄'),
      width: '1000',
      name: 'expressForward',
      url: require('@/views/modal/orderCenter/expressForward.vue').default,
      excludeString: 'expressForward',
    },
    giftExchangeConfig: {
      title: t('选择兑换赠品'),
      width: 1200,
      name: 'giftExchange',
      url: require('@/views/modal/orderCenter/giftExchange.vue').default,
      excludeString: 'giftExchange',
    },
    giftExchangeResetNumConfig: {
      title: t('重置兑换次数申请'),
      width: 1200,
      name: 'giftExchangeResetNum',
      url: require('@/views/modal/orderCenter/giftExchangeResetNum.vue').default,
      excludeString: 'giftExchangeResetNum',
    },
    manuallyFillLogisticsConfig: {
      title: t('手工填写物流单号'),
      width: '400',
      name: 'manuallyFillLogistics',
      url: require('@/views/modal/orderCenter/manuallyFillLogistics.vue').default,
      excludeString: 'manuallyFillLogistics',
    },
    updateSNConfig: {
      title: t('修改SN/IMEI信息'),
      width: 480,
      name: 'updateSN', // 组件名称
      url: require('@/views/modal/orderCenter/updateSN').default,
      excludeString: 'updateSN', // 将name传进去，确认不缓存
    },
    batchArrivedOrder: {
      width: '400',
      name: 'batchArrivedOrder',
      url: require('@/views/modal/orderCenter/batchArrivedOrder.vue').default,
      excludeString: 'batchArrivedOrder',
      title: t('批量签收')
    },
    updateGiftCard: {
      title: t('修改礼品卡信息'),
      width: 500,
      url: require('@/views/modal/orderCenter/updateGiftCard.vue').default,
      name: 'updateGiftCard',
      excludeString: 'updateGiftCard',
    },
    saleConfig: {
      title: t('新增售后申请单'),
      width: 1200,
      name: 'AFTER_SALE_APPLY_ORDER',
      url: require('@/views/modal/orderCenter/AFTER_SALE_APPLY_ORDER.vue').default,
      excludeString: 'AFTER_SALE_APPLY_ORDER',
    },
    chooseOrder: {
      title: t('选择订单'),
      width: 1000,
      url: require('@/views/pages/orderCenter/scanIn2/chooseOrder.vue').default,
      name: 'chooseOrder',
      excludeString: 'chooseOrder',
    },
    fillPriceDifference: {
      title: t('补差价'),
      width: 400,
      url: require('@/views/modal/orderCenter/fillPriceDifference.vue').default,
      name: 'fillPriceDifference',
      excludeString: 'fillPriceDifference',
    },
    ReciprocalExchange: {
      width: '800',
      name: 'ReciprocalExchange',
      url: require('@/views/modal/orderCenter/ReciprocalExchange.vue').default,
      excludeString: 'ReciprocalExchange',
      title: t('对等换货')
    },
    SpecifyExpiryDate: {
      width: '850',
      name: 'SpecifyExpiryDate',
      url: require('@/views/pages/orderCenter/orderManager/SpecifyExpiryDate.vue').default,
      excludeString: 'SpecifyExpiryDate',
      title: t('手动指定效期')
    },
    OC_ORDER_SEND_TIME: {
      title: t('修改预计发货时间'),
      width: 400,
      // url: 'modal/orderCenter/modifyPreDate',
      url: require('@/views/modal/orderCenter/modifyPreDate.vue').default,
      name: 'modifyPreDate',
      excludeString: 'modifyPreDate',
    },
    ModifyRemarks: {
      title: t('修改单据备注'),
      width: 650,
      // url: 'modal/orderCenter/returngood/rturngoodModifyRemarks',
      url: require('@/views/modal/orderCenter/returngood/rturngoodModifyRemarks.vue').default,
      name: 'rturngoodModifyRemarks',
      excludeString: 'rturngoodModifyRemarks',
    },
    // 零售发货单详情
    address: {
      title: t('修改收货地址'),
      width: 750,
      // url: 'modal/orderCenter/resolveAddress',
      url: require('@/views/modal/orderCenter/resolveAddress.vue').default,
      name: 'addressDialog',
      excludeString: 'addressDialog',
    },
    blacklist: {
      title: t('加入黑名单'),
      width: 400,
      // url: 'order/joinBlackList',
      url: require('@/views/modal/orderCenter/resolveAddress.vue').default,
      name: 'blackListDialog',
      excludeString: 'blackListDialog',
    },
    addGift: {
      title: t('添加赠品'),
      width: 1000,
      // url: 'modal/orderCenter/addGiftItem',
      url: require('@/views/modal/orderCenter/addGiftItem.vue').default,
      name: 'addGiftDialog',
      excludeString: 'addGiftDialog',
    },
    changeSku: {
      title: t('替换商品'),
      width: 800,
      // url: 'modal/orderCenter/replaceGoodsDetail',
      url: require('@/views/modal/orderCenter/replaceGoodsDetail.vue').default,
      name: 'changeSkuDialog',
      excludeString: 'changeSkuDialog',
    },
    // modifyRemark: {
    //   title: t('修改备注'),
    //   width: 480,
    //   // url: 'modal/orderCenter/changeRemark',
    //   url: require('@/views/modal/orderCenter/changeRemark.vue').default,
    //   name: 'modifyRemarkDialog',
    //   excludeString: 'modifyRemarkDialog',
    // },
    changeRemarkConfig: {
      title: t('修改卖家备注'),
      width: '480',
      name: 'changeRemark',
      // url: 'modal/orderCenter/changeRemark',
      url: require('@/views/modal/orderCenter/changeRemark.vue').default,
      excludeString: 'changeRemark',
    },
    modifyLogisticsConfig: {
      title: t('批量修改物流'),
      width: '400',
      name: 'modifyLogistics',
      // url: 'modal/orderCenter/modifyLogistics',
      url: require('@/views/modal/orderCenter/modifyLogistics.vue').default,
      excludeString: 'modifyLogistics',
    },
    modifyReturnLogistics: {
      title: t('修改退回物流公司'), // 批量修改物流
      width: '400',
      name: 'modifyReturnLogistics',
      url: require('@/views/modal/orderCenter/modifyReturnLogistics.vue').default,
      excludeString: 'modifyReturnLogistics',
    },
    makeOutInvoiceConfig: {
      title: t('记录发票'),
      width: '600',
      name: 'makeOutInvoice',
      // url: 'modal/orderCenter/makeOutInvoice',
      url: require('@/views/modal/financeCenter/creatInvoice.vue').default,
      excludeString: 'makeOutInvoice',
    },
    addGiftsConfig: {
      title: t('添加赠品'),
      width: '1100',
      name: 'addGifts',
      // url: 'modal/orderCenter/addGifts',
      url: require('@/views/modal/orderCenter/addGifts.vue').default,
      excludeString: 'addGifts',
    },
    // 弹框配置 拖拽排序
    dropSortConfig: {
      title: t('排序表单'),
      width: '300',
      name: 'setFormDrag',
      // url: 'modal/orderCenter/setFormDrag',
      url: require('@/views/modal/orderCenter/setFormDrag.vue').default,
      excludeString: 'setFormDrag',
    },
    goodsDetailConfig: {
      title: t('订单明细'),
      width: '900',
      name: 'goodsDetail',
      // url: 'modal/orderCenter/goodsDetail',
      url: require('@/views/modal/orderCenter/goodsDetail.vue').default,
      excludeString: 'goodsDetail',
    },
    changeWarehouseConfig: {
      title: t('批量修改仓库'),
      width: '400',
      name: 'changeWarehouse',
      // url: 'modal/orderCenter/changeWarehouse',
      url: require('@/views/modal/orderCenter/changeWarehouse.vue').default,
      excludeString: 'changeWarehouse',
    },
    depositPresaleConfig: {
      title: t('定金预售提前发货打标'),
      width: '800',
      name: 'manualMarking',
      // url: 'modal/orderCenter/manualMarking',
      url: require('@/views/modal/orderCenter/manualMarking.vue').default,
      excludeString: 'manualMarking',
    },
    replaceConfig: {
      title: t('批量替换商品'),
      width: '1000',
      name: 'replaceTheGoods',
      // url: 'modal/orderCenter/changeProduct',
      url: require('@/views/modal/orderCenter/changeProduct.vue').default,
      excludeString: 'replaceTheGoods',
    },
    pushProduceConfig: {
      title: t('批量添加赠品'),
      width: '900',
      name: 'pushProduce',
      // url: 'modal/orderCenter/pushProduce',
      url: require('@/views/modal/orderCenter/pushProduce.vue').default,
      excludeString: 'pushProduce',
    },
    itemDeleteConfig: {
      title: t('批量删除赠品'),
      width: '800',
      name: 'itemDelete',
      // url: 'modal/orderCenter/itemDelete',
      url: require('@/views/modal/orderCenter/itemDelete.vue').default,
      excludeString: 'itemDelete',
    },
    specifyGoodsAssignConfig: {
      title: t('指定商品拆单'),
      width: '700',
      name: 'specifyGoodsAssign',
      url: require('@/views/modal/orderCenter/specifyGoodsAssign.vue').default,
      excludeString: 'specifyGoodsAssign',
      componentData: {},
      quit: function () {
        this.closeConfirm()
      },
    },
    //弹框配置 零售发货单详情界面替换商品弹框
    replaceGoodsDetailConfig: {
      title: t('替换商品'),
      width: '700',
      name: 'replaceGoodsDetail',
      // url: 'pages/orderCenter/orderManager/replaceGoodsDetail',
      url: require('@/views/modal/orderCenter/replaceGoodsDetail.vue').default,
      excludeString: 'replaceGoodsDetail',
    },
    updateEstimateConTime: {
      title: t('修改预计发货时间'), // Hold单
      width: '400',
      name: 'updateEstimateConTime',
      url: require('@/views/modal/orderCenter/updateEstimateConTime.vue').default,
      excludeString: 'updateEstimateConTime',
      componentData: {},
      quit: function () {
        this.closeConfirm()
      },
    },
    // 周期购预计发货时间修改
    cycleUpdateEstimateConTime: {
      title: t('修改周期购预计发货时间'),
      width: '400',
      name: 'cycleUpdateEstimateConTime',
      url: require('@/views/modal/orderCenter/cycleUpdateEstimateConTime.vue').default,
      excludeString: 'cycleUpdateEstimateConTime',
      componentData: {},
      quit: function () {
        this.closeConfirm()
      },
    },
    warehouseLogistics: {
      title: t('寻仓寻物流'),
      width: '1000',
      name: 'warehouseLogistics',
      url: require('@/views/modal/orderCenter/warehouseLogistics/warehouseLogistics.vue').default,
      excludeString: 'warehouseLogistics',
      componentData: {},
      quit: function () {
        this.closeConfirm()
      },
    },
    // logicalOccupation: {
    //   title: '逻辑占用明细查询',
    //   width: '1000',
    //   name: 'logicalOccupation',
    //   url: require('@/views/modal/orderCenter/warehouseLogistics/logicalOccupation.vue').default,
    //   excludeString: 'logicalOccupation',
    //   componentData: {},
    //   quit: function () {
    //     this.closeConfirm()
    //   },
    // },
    // logicalBinLotInventory: {
    //   title: '逻辑仓批次库存查询',
    //   width: '1000',
    //   name: 'logicalBinLotInventory',
    //   url: require('@/views/modal/orderCenter/warehouseLogistics/logicalBinLotInventory.vue').default,
    //   excludeString: 'logicalBinLotInventory',
    //   componentData: {},
    //   quit: function () {
    //     this.closeConfirm()
    //   },
    // },
    holdOrderConfig: {
      title: t('Hold单'),
      width: '500',
      name: 'holdOrderDialog',
      // url: 'modal/orderCenter/holdOrderDialog',
      url: require('@/views/modal/orderCenter/holdOrderDialog.vue').default,
      excludeString: 'holdOrderDialog',
      componentData: {},
      quit: function () {
        this.closeConfirm()
      },
    },
    batchDetentionConfig: {
      title: t('卡单'), // 卡单
      width: '500',
      name: 'batchDetentionDialog',
      url: require('@/views/modal/orderCenter/batchDetentionDialog.vue').default,
      excludeString: 'batchDetentionDialog',
      componentData: {},
      quit: function () {
        this.closeConfirm()
      },
    },
    scheduleFormConfig: {
      title: t('入库单'), // 入库单、拣货单
      width: '800',
      name: 'scheduleFormDialog',
      // url: 'modal/strategyPlatform/scheduleFormDialog',
      url: require('@/views/modal/strategyPlatform/scheduleFormDialog.vue').default,
      excludeString: 'scheduleFormDialog',
    },
    copyPermissionConfig: {
      title: t('复制权限'), // 复制权限
      width: 400,
      name: 'copyPermission',
      // url: 'modal/systemConfig/copyPermission',
      url: require('@/views/modal/systemConfig/copyPermission.vue').default,
      excludeString: 'copyPermission',
    },
    // 弹窗配置 会员加急发货
    vipSpeedDispatchConfig: {
      title: t('会员加急发货打标'),
      width: 400,
      name: 'manualMarking',
      // url: 'modal/orderCenter/manualMarking',
      url: require('@/views/modal/orderCenter/manualMarking.vue').default,
      excludeString: 'manualMarking'
    },
    VirtuallySendGoodsConfig: {
      title: t('虚拟发货'),
      width: '800',
      name: 'VirtuallySendGoods', // 组件名称
      url: require('@/views/modal/orderCenter/VirtuallySendGoods').default,
      excludeString: 'VirtuallySendGoods', // 将name传进去，确认不缓存
    },
    updateDeliveryInfoConfig: {
      title: '',
      width: '440',
      name: 'updateDeliveryInfoVue',
      url: require('@/views/modal/orderCenter/updateDeliveryInfoVue').default,
      excludeString: 'updateDeliveryInfoVue',
    },
    changeInternalRemarksConfig: {
      title: t('修改内部备注'),
      width: '440',
      name: 'changeInternalRemarks', // 组件名称
      url: require('@/views/modal/orderCenter/changeInternalRemarks').default,
      excludeString: 'changeInternalRemarks', // 将name传进去，确认不缓存
    },
    changeDetailRemarkConfig: {
      title: t('修改备注'),
      width: '440',
      name: 'changeDetailRemarks', // 组件名称
      url: require('@/views/modal/orderCenter/changeRemark2').default,
      excludeString: 'changeDetailRemarks', // 将name传进去，确认不缓存
    },
    promotionGiftSetConfig: {
      title: t('批量设置'), // 批量设置
      width: '440',
      name: 'batchGiftSet',
      url: require('@/views/modal/promotionCenter/batchGiftSet.vue').default,
      excludeString: 'batchGiftSet',
    },
  }
  static config() {
    return (this.customConfig = Object.fromEntries(
      Object.entries(this.customConfig).map(([key, value]) => {
        // (如果目标对象与源对象有同名属性，或多个) ==> 源对象有同名属性，则后面的属性会覆盖前面的属性
        // return [key, Object.assign(this.baseObj, value)];
        return [
          key,
          Object.fromEntries(
            Object.entries(this.baseObj).concat(Object.entries(value))
          ),
        ]
      })
    ))
  }
}

export default DialogConfig
